import { cn } from "@/lib/utils";

interface BrandBoltProps {
  className?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  animate?: boolean;
  variant?: 'default' | 'glow' | 'pulse' | 'bounce';
}

const sizeClasses = {
  xs: 'h-4 w-3',
  sm: 'h-5 w-4',
  md: 'h-6 w-5',
  lg: 'h-8 w-6',
  xl: 'h-10 w-8',
  '2xl': 'h-12 w-10',
};

const animationClasses = {
  default: '',
  glow: 'drop-shadow-[0_0_8px_#FFD700]',
  pulse: 'animate-pulse drop-shadow-[0_0_12px_#FFD700]',
  bounce: 'animate-bounce drop-shadow-[0_0_8px_#FFD700]',
};

/**
 * BrandBolt - The official ESKO Servis lightning bolt brand icon
 * Use this component instead of lucide-react Zap icon for brand consistency
 */
const BrandBolt = ({ 
  className, 
  size = 'md', 
  animate = false,
  variant = 'default'
}: BrandBoltProps) => {
  return (
    <svg
      viewBox="0 0 32 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(
        sizeClasses[size],
        animate && 'bolt-pulse',
        animationClasses[variant],
        'transition-all duration-300',
        className
      )}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="brandBoltGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FFDD00" />
          <stop offset="50%" stopColor="#FFD700" />
          <stop offset="100%" stopColor="#FFCC00" />
        </linearGradient>
        <filter id="brandBoltGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="2" result="coloredBlur" />
          <feMerge>
            <feMergeNode in="coloredBlur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <path
        d="M20 0L6 22H14L10 48L28 18H18L20 0Z"
        fill="url(#brandBoltGradient)"
        filter="url(#brandBoltGlow)"
      />
    </svg>
  );
};

export default BrandBolt;
